import { Routes, Route } from "react-router-dom";

import Home from "../pages/home/home";
import AboutUs from "../pages/aboutUs/aboutUs";
import Project from "../pages/project/project";
import Accountability from "../pages/accountability/accountability";
import Property from "../pages/property/property";
import Team from "../pages/team/team";
import News from "../pages/news/news";
import Journal from "../pages/journal/journal";
import Event from "../pages/event/event";
import Space from "../pages/space/space";
import ContactUs from "./../pages/contactus/contactus";
import Login from "../pages/login/login";
import DefaultLayout from "../dashboard/layout/DefaultLayout";
import PageNotFound from "../pages/pageNotFound/pageNotFound";

function AppRoutes() {
  return (
    <Routes>
      <Route path={`/`} element={<Home />} />
      <Route path={`/home`} element={<Home />} />
      <Route path={`/aboutus`} element={<AboutUs />} />
      <Route path={`/project`} element={<Project />} />
      <Route path={`/project/:id`} element={<Project />} />
      <Route path={`/accountability`} element={<Accountability />} />
      <Route path={`/accountability/:id`} element={<Accountability />} />
      <Route path={`/property`} element={<Property />} />
      <Route path={`/property/:id`} element={<Property />} />
      <Route path={`/collaborator`} element={<Team />} />
      <Route path={`/news`} element={<News />} />
      <Route path={`/news/:id`} element={<News />} />
      <Route path={`/journal`} element={<Journal />} />
      <Route path={`/event`} element={<Event />} />
      <Route path={`/event/:id`} element={<Event />} />
      <Route path={`/space`} element={<Space />} />
      <Route path={`/login`} element={<Login />} />
      <Route path={`/contact`} element={<ContactUs />} />
      <Route path={`/dashboard/*`} element={<DefaultLayout />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default AppRoutes;
